import React, { useState } from 'react';
import { Tooltip, IconButton, Menu, MenuItem, ListItemText, Typography } from '@mui/material';
import HubIcon from '@mui/icons-material/Hub';
import { AI_PROVIDERS, getAiProvider, setAiProvider } from '../../utils/aiProvider';

/**
 * #106: lets the user pick the AI provider / source (GitHub Models playground or
 * OpenRouter, or the server default). The choice is stored in localStorage and
 * sent as the `X-LLM-Provider` header; switching re-fetches the model list for
 * that source. Pair with the key entry (ApiKeySettings) for your own key.
 */
const ProviderSelector = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [provider, setProvider] = useState(getAiProvider());

  const open = (e) => setAnchorEl(e.currentTarget);
  const close = () => setAnchorEl(null);

  const choose = (id) => {
    setAiProvider(id);          // persists + dispatches the change event (models refetch)
    setProvider(id);
    close();
  };

  const active = AI_PROVIDERS.find((p) => p.id === provider) || AI_PROVIDERS[0];
  const isOverridden = Boolean(provider);

  return (
    <>
      <Tooltip title={`AI source: ${active.label}`}>
        <IconButton
          size="small"
          onClick={open}
          aria-label="Select AI provider/source"
          sx={{ color: isOverridden ? 'primary.main' : 'inherit' }}
        >
          <HubIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
        <Typography variant="caption" sx={{ px: 2, py: 0.5, display: 'block', color: 'text.secondary' }}>
          AI source
        </Typography>
        {AI_PROVIDERS.map((p) => (
          <MenuItem
            key={p.id || 'default'}
            selected={p.id === provider}
            onClick={() => choose(p.id)}
            sx={{ fontSize: '0.875rem' }}
          >
            <ListItemText primary={p.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ProviderSelector;
